export default __webpack_public_path__ + "static/media/iconOperaciones.1e8e52a8.png";